import { FC, FocusEvent, useState } from 'react';
import { Button, DatePicker } from 'antd';
import moment from 'moment';

interface StartDueDatePickerProps {
  value?: [moment.Moment | null, moment.Moment | null] | null;
  onChange?: (value: [moment.Moment | null, moment.Moment | null] | null) => void;
}

const StartDueDatePicker: FC<StartDueDatePickerProps> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [activeSide, setActiveSide] = useState<'start' | 'end'>('start');

  const disabledDate = (current: moment.Moment) => {
    if (!current) {
      return false;
    }

    const end = value?.[1] ?? null;

    if (activeSide === 'end') {
      return !current.isAfter(moment(), 'day');
    }

    return !!end && current.isAfter(end, 'day');
  };

  // antd v4 does not expose the active range panel, so detect the focused input from the DOM.
  const handleFocusCapture = (event: FocusEvent<HTMLDivElement>) => {
    const inputWrapper = (event.target as HTMLElement).closest('.ant-picker-input');
    const picker = inputWrapper?.closest('.ant-picker');

    if (!inputWrapper || !picker) {
      return;
    }

    const inputs = Array.from(picker.querySelectorAll('.ant-picker-input'));
    setActiveSide(inputs.indexOf(inputWrapper) === 1 ? 'end' : 'start');
  };

  return (
    <div className="w-full" onFocusCapture={handleFocusCapture}>
      <DatePicker.RangePicker
        open={open}
        value={value}
        onChange={onChange}
        disabledDate={disabledDate}
        className="w-full ant-picker-short-format ant-picker-yy"
        size="small"
        format="MMM DD, YY"
        placeholder={['Start date', 'Due date']}
        separator="-"
        renderExtraFooter={() => (
          <div style={{ display: 'flex', justifyContent: 'right', padding: '8px 0' }}>
            <Button type="primary" size="small" onClick={() => setOpen(false)}>
              Ok
            </Button>
          </div>
        )}
        onOpenChange={setOpen}
      />
    </div>
  );
};

export default StartDueDatePicker;
